import { config } from "@/config";
import mixpanel from "mixpanel-browser";
import { useEffect } from "react";
import { useLocation } from "react-router-dom";

/**
 * We use data-tracking-title to provide consistent titles for pages that
 * dynamically update with the resource name, which is based on user-generated content.
 * This ensures more reliable and meaningful analytics data.
 *
 * The timeout is used to ensure the proper title is captured after route changes.
 * This slight delay allows for any asynchronous title updates to complete
 * before we track the page view, resulting in more accurate tracking.
 */
export function useTrackPageView() {
  const location = useLocation();

  useEffect(() => {
    if (config.mixpanel.enabled) {
      setTimeout(() => {
        const titleTag = document.getElementsByTagName("title")[0];
        const titleOverride = titleTag?.getAttribute("data-tracking-title");

        let title = titleOverride || document.title;

        mixpanel.track_pageview({
          current_page_title: title,
        });
      }, 100);
    }
  }, [location.pathname]);
}
